import React, { useRef, useEffect, useState } from "react";
import auto from "../../assets/images/Home/robot-talking.gif";
import analyze from "../../assets/images/Home/analyze.gif";
import assist from "../../assets/images/Home/chat-bot.gif";
import manage from "../../assets/images/Home/personnel.gif";

import redefine_images from "../../assets/images/Home/Redefine_Customer.jpeg";

const features = [
  {
    icon: auto,
    number: "01",
    title: "	Automate",
    desc: "24×7 AI Chatbot + Alarm Centre.",
    active: true,
  },
  {
    icon: analyze,
    number: "02",
    title: "Analyze",
    desc: "Real-time Insights on Support Performance.",
    active: false,
  },
  {
    icon: assist,
    number: "03",
    title: "	Assist",
    desc: "Tailored Support for Better Customer Experience.",
    active: false,
  },
  {
    icon: manage,
    number: "04",
    title: "Manage",
    desc: "Centralized Dashboard for Agents & Services.",
    active: false,
  },
];

function FeatureCard({ icon, number, title, desc, active, visible, delay }) {
  // Use inline style for animation
  return (
    <div
      className={`why-choose-card transition-all duration-500 shadow-md flex flex-col mt-3 items-center justify-center ${
        active
          ? "bg-[#fff] text-black border-[#fff] shadow-lg"
          : "bg-white text-[#000] border-[#e5e7eb] hover:shadow-md"
      }`}
      style={{
        minHeight: 130,
        maxWidth: 235,
        position: "relative",
        zIndex: 2,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0px)" : "translateY(32px)",
        transition:
          "opacity 0.5s cubic-bezier(.4,0,.2,1), transform 0.5s cubic-bezier(.4,0,.2,1)",
        transitionDelay: visible ? `${delay}ms` : "0ms",
        pointerEvents: visible ? "auto" : "none",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <div className="flex flex-col items-center justify-center gap-2 px-5 pt-5 w-full">
        <div
          className={`flex items-center justify-center rounded-full bg-[#f2f7ff] text-black ${
            active ? "bg-white text-black" : ""
          }`}
          style={{ width: 60, height: 60 }}
        >
          <img
            src={icon}
            alt={title}
            className="gif-color-change"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </div>
        <span
          className={`numbers-why-choose opacity-40 mt-2 ${
            active ? "text-white opacity-60" : "text-[#183153]"
          }`}
          style={{ textAlign: "center", fontWeight: 600, fontSize: "1.1rem" }}
        >
          {number}
        </span>
      </div>
      <div className="px-5 pb-5 pt-2 w-full flex flex-col items-center justify-center text-center">
        <h3
          className={`text-base mb-1 ${
            active ? "text-black" : "text-[#183153]"
          }`}
          style={{ textAlign: "center", fontWeight: 600 }}
        >
          {title}
        </h3>
        <p
          className={`text-sm ${active ? "text-black/80" : "text-[#555]"}`}
          style={{ textAlign: "center" }}
        >
          {desc}
        </p>
      </div>
    </div>
  );
}

const InsuranceSection = () => {
  const sectionRef = useRef(null);
  const [imageVisible, setImageVisible] = useState(false);
  const [cardsVisible, setCardsVisible] = useState([
    false,
    false,
    false,
    false,
  ]);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile on mount and on resize
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 768);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let observer;
    let timeoutIds = [];

    if (sectionRef.current) {
      observer = new window.IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setImageVisible(true);

            // Animate cards one by one after image (or immediately for mobile)
            features.forEach((_, idx) => {
              const timeout = setTimeout(
                () => {
                  setCardsVisible((prev) => {
                    if (prev[idx]) return prev;
                    const updated = [...prev];
                    updated[idx] = true;
                    return updated;
                  });
                },
                isMobile ? idx * 250 : 600 + idx * 250
              );
              timeoutIds.push(timeout);
            });

            observer.disconnect();
          }
        },
        {
          threshold: 0.3,
        }
      );
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer) observer.disconnect();
      timeoutIds.forEach((id) => clearTimeout(id));
    };
  }, [isMobile]);

  return (
    <section
      ref={sectionRef}
      className="w-full bg-white py-12 px-2 md:px-0 why-choose-us-main-container"
    >
      {/* Mobile Layout: Cards first, then image */}
      <div
        className="block md:hidden max-w-screen-xl mx-auto"
        style={{ padding: "0 1rem" }}
      >
        <div className="mb-6">
          {/* <span className="inline-block why-choose-heading text-xs  px-4 py-1 rounded-full tracking-wide shadow-sm border border-[#e0e7ef] mb-2">
            Why Choose Us
          </span> */}
          <h2 className="text-2xl sm:text-3xl font-extraboldd text-[#183153] leading-tight mb-3">
            Redefine Customer Service with Across Assist
          </h2>
          <p className="text-[#555] text-base mb-7 max-w-xxl">
            Across Assist puts your needs first, offering personalized support
            and proactive solutions. Our service is reliable, empathetic, and
            innovative. We’re always by your side to assist, guide, and protect.
            Experience a seamless journey with a trusted partner.
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 mb-8">
          {features.map((f, idx) => (
            <FeatureCard
              key={f.number}
              icon={f.icon}
              // number={f.number}
              title={f.title}
              desc={f.desc}
              active={f.active}
              visible={cardsVisible[idx]}
              delay={idx * 250}
            />
          ))}
        </div>
        <div className="w-full flex items-center justify-center mb-4">
          <div className="relative w-full h-[220px] xs:h-[180px]">
            <img
              src={redefine_images}
              alt="Happy people"
              className={`rounded-2xl w-full object-cover transition-all duration-700 ${
                imageVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{
                minHeight: "100%",
                maxHeight: "100%",
                objectFit: "fill",
                borderStyle: "none",
                border: "none",
                maxWidth: "100%",
                transitionProperty: "opacity, transform",
              }}
            />
            {/* Decorative zigzag */}
            <svg
              className="absolute -top-6 left-0"
              width={60}
              height={16}
              viewBox="0 0 60 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ zIndex: 3 }}
            >
              <polyline
                points="0,8 8,0 16,8 24,0 32,8 40,0 48,8 56,0"
                stroke="#fe7c0b"
                strokeWidth={3}
                fill="none"
              />
            </svg>
          </div>
        </div>
      </div>
      {/* Desktop Layout: Keep original structure */}
      <div
        className="hidden md:flex max-w-screen-xl mx-auto flex-col md:flex-row items-stretch gap-8"
        style={{
          padding: "0 2.5rem",
        }}
      >
        {/* Left Content */}
        <div className="md:w-7/12 flex flex-col justify-between">
          <div className="text-with-cards-container flexx justify-around ">
            <div className="text-content-why-choose">
              {/* <div className="mb-2">
                <span className="inline-block why-choose-heading text-xs  px-4 py-1 rounded-full tracking-wide shadow-sm border border-[#e0e7ef]">
                  Why Choose Us
                </span>
              </div> */}
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#183153] leading-tight mb-3">
                Redefine Customer Service
              </h2>
              <p className="text-[#555] text-base mb-7 max-w-xxl">
                Across Assist puts your needs first, offering personalized
                support and proactive solutions. Our service is reliable,
                empathetic, and innovative. We’re always by your side to assist,
                guide, and protect. Experience a seamless journey with a trusted
                partner.
              </p>
            </div>
            {/* 4 cards should be in bottom side as per made  */}
            <div className="grid grid-cols-4 sm:grid-cols-4 gap-4 z-9999 absolute botto mt-8 ">
              {features.map((f, idx) => (
                <FeatureCard
                  key={f.number}
                  icon={f.icon}
                  // number={f.number}
                  title={f.title}
                  desc={f.desc}
                  active={f.active}
                  visible={cardsVisible[idx]}
                  delay={idx * 250}
                />
              ))}
            </div>
          </div>
        </div>
        {/* Right Image */}
        <div className="md:w-5/12 flex items-center justify-center relative">
          <div className="relative w-full lg:h-[500px] xs:h-[350px] md:h-[506px] ">
            <img
              src={redefine_images}
              alt="Happy people"
              className={`rounded-2xl w-full object-cover transition-all duration-700 ${
                imageVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-8"
              }`}
              style={{
                minHeight: "100%",
                maxHeight: "100%",
                objectFit: "fill",
                borderStyle: "none",
                border: "none",
                maxWidth: "100%",
                transitionProperty: "opacity, transform",
              }}
            />
            {/* Decorative zigzag */}
            {/* <svg
              className="absolute -top-6 left-0"
              width={60}
              height={16}
              viewBox="0 0 60 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ zIndex: 3 }}
            >
              <polyline
                points="0,8 8,0 16,8 24,0 32,8 40,0 48,8 56,0"
                stroke="#fe7c0b"
                strokeWidth={3}
                fill="none"
              />
            </svg> */}
          </div>
        </div>
      </div>
      {/* Animation styles */}
      <style>{`
        .why-choose-card {
          will-change: opacity, transform;
        }
      `}</style>
    </section>
  );
};

export default InsuranceSection;
